<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             size="lg"
             no-close-on-esc
             no-close-on-backdrop
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row>
              <b-col>
                <b-input v-on:keyup.enter="onScan()" autofocus type="text" v-model="form.chave_nfe"></b-input>
                <span>Qtde. caracteres código de barra: {{qtdCaracteres()}}</span>
              </b-col>
              <b-col>
                <b-btn :disabled="loading" @click="onScan()" variant="secondary">Escanear código</b-btn>
              </b-col>
              <b-col md="2" class="p-0">
                <b-input hidden disabled type="text"></b-input>
              </b-col>
            </b-row>
        </form>
        <div class="loadingDataPosition">
            <div class="loadingData" v-if="loading"></div>
              <vuetable ref="vuetable"
                      :api-mode="false"
                      :data="notas_fiscais"
                      :fields="fields"
                      :css="css"
                      :append-params="moreParams"
                      track-by="docfis_id"
                      pagination-path=""
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                      detail-row-component="expedicaocargaform-detalhes"
                      @vuetable:cell-clicked="onDetail"
                    >
                    <template slot="ordem" slot-scope="props">
                        <span>{{ props.rowIndex+1 }}</span>
                    </template>
                    <template slot="num_controle_cte" slot-scope="props">
                        <span>{{ props.rowData }}</span>
                    </template>
              </vuetable>
          </div>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                 <b-btn @click="onStore()" variant="secondary" :disabled="this.isDisabled">
                   Imprimir
                 </b-btn>
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import { formatCNPJFromParts } from "../utils";


import AvisoErros from '../components/AvisoErros'
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import ExpedicaoCargaFormDetalhes from './ExpedicaoCargaFormDetalhes.vue'
Vue.component('expedicaocargaform-detalhes', ExpedicaoCargaFormDetalhes);

export default {
components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ExpedicaoCargaFormDetalhes,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      permite_digitar: false,
      loading: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      errors_array: [],
      notas_fiscais: [],
      cd_barra: '',
      nota: {
        cnpj: '',
        num_fiscal:'',
        serie:'',
        num_volume: '',
      },
      docfis: [],
      form: new Form({
          chave_nfe:'',
          notas_fiscais: []
                   }),
     helpForm: new Form({search:'', docfis_id: '', carga_id: ''}),
     fields: [
      {
        name: 'num_fiscal',
        title: 'N° Fiscal',
      },
      {
        name: '__slot:ordem',
        title: 'Ordem',
      },
      {
        name:'num_controle',
        title: 'N° Controle CTE'
      },
      {
        name:'regiao',
        title: 'Regiao'
      }
     ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.docfisttra_id);
        }
    },
      onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit('setVuetableFilterButton', false);
    },
      onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onCreate (data, tipo)
    {
      this.permite_digitar = this.checkPermissionBip();
      this.errors_array = '';
      this.errors_array = [];
      this.docfis = [];
      this.isDisabled = true;
      this.loading = false;
      this.modal_titulo = "Imprimir por chave NFe";
      this.modal_botao = "Imprimir";
      this.modal_acao = "i";
      this.form.reset();
      this.notas_fiscais = [];
      this.$refs.modal_form.show();
    },
    onScan() {
      this.errors_array = [];
      this.loading = true;
      this.isDisabled = true;
      this.form.notas_fiscais = [];
        this.form.post('/api/cte/checknfe').then(response => {
          new ReturnApi(response, this);

          let notaComCTE = null
          const notaFiscalSemCarga = response.carga_doc !== null;
          const temCte = notaFiscalSemCarga && response.carga_doc.doc_carga_doc !== null;
          if(temCte) {
            notaComCTE = response.carga_doc.doc_carga_doc.doc;
          }
          const numeroControleCTE = notaComCTE && notaComCTE.num_controle;

          if(!temCte) {
            this.isDisabled = true;
          }

          let regiaoRPS = '';
          if(notaComCTE && notaComCTE.doc_rps && Object.keys(notaComCTE.doc_rps).length ) {
            regiaoRPS = notaComCTE.doc_rps.doc_rps_regiao.texto;
          }

          let regiaoCTE = '';
          if(notaComCTE && notaComCTE.regiao_despesa && Object.keys(notaComCTE.regiao_despesa).length) {
            regiaoCTE = `${notaComCTE.regiao_despesa.cd} | ${notaComCTE.regiao_despesa.descr}`;
          }

          const regiaoNotaFiscal = response.doc_fiscal_partes_env.des_regiao != null ? response.doc_fiscal_partes_env.des_regiao.descr : '';

          this.notas_fiscais.push({
              num_controle: numeroControleCTE || 'N/A',
              chave: response.chave,
              regiao: regiaoCTE || regiaoRPS || regiaoNotaFiscal,
              docfis_id: response.docfis_id,
              num_fiscal: response.num_fiscal,
          })
          this.form.notas_fiscais = this.notas_fiscais
          this.form.chave_nfe = '';
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/cte/imprimirctepornfe').then(response =>
        {
            new ReturnApi(response, this)
            this.$parent.onFilterReset();

        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/montagemcarga/transportadora/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            this.$parent.onFilterReset();
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    // onRemoveNf(data){
    //   this.helpForm.docfis_id = data.docfis_id;
    //   this.helpForm.carga_id = data.carga_id;
    //
    //   this.loading = true;
    //   this.isDisabled = true;
    //   this.helpForm.patch('/api/montagemcarga/bip/status').then(response =>
    //   {
    //       new ReturnApi(response, this, true, null, null, false)
    //       this.notas_fiscais.splice(data);
    //   })
    //   .catch(errors =>
    //   {
    //       new ReturnApi(errors, this, true, null, null, false);
    //       this.errors_array = '';
    //       this.errors_array = [];
    //       for (var property in errors) {
    //         if (errors.hasOwnProperty(property)) {
    //           if (typeof(errors[property]) === 'object') {
    //             errors[property].forEach((obj) => {
    //               this.errors_array.push({
    //                 erro: obj
    //               });
    //             });
    //           }
    //         }
    //       }
    //   });
    // },
    onRowClass (data, index) {
      return (data.qtde_bipada == data.qtde_total) ? 'table-success' : 'table-warning';
    },
    checkPermissionBip() {
        return this.getPermissionFw('expedicao.digitaretiqueta');//
    },
    onDetail (data, field, event) {
        this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
            onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
      },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
    qtdCaracteres(){
      return this.cd_barra.length;
    }
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>